module.exports = __webpack_public_path__ + "img/plt.96d4d3fc.svg";